/**
 * @generated SignedSource<<71c6d69da33c925d4386aec81f5ca358>>
 * @relayHash da578a46e2a4a46ae3c5eb108e6aece2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID cf8227661b79d9d804ccd0ae680859dd3332a77eaaaf9359b3b45dc8009d44f7

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { AgentContextQuery } from './AgentContextQuery.graphql';

const node: PreloadableConcreteRequest<AgentContextQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "cf8227661b79d9d804ccd0ae680859dd3332a77eaaaf9359b3b45dc8009d44f7",
    "metadata": {},
    "name": "AgentContextQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
